export default __webpack_public_path__ + "static/media/trips_page_bg.58fcf26f.svg";